import powerBiApi from '@/api/powerbi'

const actions = {
  actionGetDashboardEmbedded (_) {
    return powerBiApi.getDashboardEmbedded()
      .then((response) => {
        return Promise.resolve(response.data)
      })
      .catch((e) => {
        return Promise.reject(e.response.data)
      })
  },
  getDashboardClientEmbedded (_, param) {
    return powerBiApi.getDashboardClientEmbedded(param)
      .then((response) => {
        return Promise.resolve(response.data)
      })
      .catch((e) => {
        return Promise.reject(e.response.data)
      })
  }
}

export default {
  actions
}
